import { CaretRightOutlined, CloseOutlined, FilterFilled } from '@ant-design/icons';
import { Button, Collapse, Skeleton, Tooltip } from 'antd';
import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { canvasSelector, setFilterList } from '../../redux/canvas/reducer';
import { BUILT_IN_COMPONENT } from '../../store/mockyData';
import { MAIN_MENU, getCategory, getPanelOpenValues, isWindow } from '../../utils';
import Element from '../Element';
import SearchForm from '../Form/SearchForm';
import FilterComponentModal from '../Modal/FilterComponentModal';
import './styles.scss';

const { Panel } = Collapse;

let timer;

const SystemComponents = ({ componentObj }) => {
  const categories = BUILT_IN_COMPONENT[componentObj.componentType];

  const canvasData = useSelector(canvasSelector);
  const categoriesData = canvasData[componentObj.componentType];

  const { filterList } = useSelector(canvasSelector);

  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const [openedPanels, setOpenPanels] = useState([]);
  const [openedSubPanels, setOpenSubPanels] = useState([]);
  const [categoriesGroup, setCategoriesGroup] = useState(categories);
  const [isShowModal, setIsShowModal] = useState(false);

  const toggleFilterComponentModal = () => {
    setIsShowModal((old) => !old);
  };

  const isSubCate = (item) => item.subCategoryName;

  const isShowCate = (cate) => filterList.find((i) => i.startsWith(cate.groupId));

  const renderComponent = (item) =>
    !isSubCate(item) ? (
      <div key={item.id}>
        <Element
          item={item}
          displayName={!(isEqual(componentObj, MAIN_MENU.icons) || isEqual(componentObj, MAIN_MENU.diagrams))}
        />
      </div>
    ) : (
      <div key={item.groupId}>
        <Collapse
          expandIcon={({ isActive }) => (
            <div className="expand-icon">
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            </div>
          )}
          bordered={false}
          expandIconPosition="start"
          className="collapse sub-cate"
          onChange={setOpenSubPanels}
          activeKey={openedSubPanels}
        >
          <Panel
            key={item.groupId}
            header={item.subCategoryName}
            style={{ paddingRight: '0px' }}
            className={'sub-cate'}
            extra={
              <Tooltip title="Deselect" placement="right" ouseLeaveDelay={0}>
                <CloseOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFilterOption(item);
                  }}
                />
              </Tooltip>
            }
          >
            <div className={'display-4'}>
              {item.componentList.map((i) => (
                <div key={i.id}>
                  <Element
                    item={i}
                    displayName={!(isEqual(componentObj, MAIN_MENU.icons) || isEqual(componentObj, MAIN_MENU.diagrams))}
                  />
                </div>
              ))}
            </div>
          </Panel>
        </Collapse>
      </div>
    );

  const removeFilterOption = (cate) => {
    let filterCateList = filterList.filter((i) => i !== cate.groupId);
    if (isSubCate(cate)) {
      const subCate = cate;
      const index = subCate.groupId.indexOf('-', subCate.groupId.indexOf('-') + 1);
      const cateGroupId = subCate.groupId.substr(0, index);
      const includesSubLength = filterCateList.filter((i) => i.includes(cateGroupId));
      setOpenSubPanels((prev) => prev.filter((i) => i !== subCate.groupId));
      if (includesSubLength.length === 1) {
        filterCateList = filterCateList.filter((i) => i !== cateGroupId);
        setOpenPanels((prev) => prev.filter((i) => i !== cateGroupId));
      }
    } else {
      setOpenPanels((prev) => prev.filter((i) => i !== cate.groupId));
      setOpenSubPanels((prev) => prev.filter((i) => !i.includes(cate.groupId)));
      const cateData = categories.find((i) => i.groupId === cate?.groupId);
      if (cateData?.subCategoryList) {
        const subCatesGroupId = cate.subCategoryList.map((i) => i.groupId);
        filterCateList = filterCateList.filter((i) => !subCatesGroupId.includes(i));
        setOpenPanels((prev) => prev.filter((i) => !subCatesGroupId.includes(i)));
      }
    }
    dispatch(setFilterList(filterCateList));
  };

  const debouncedSearch = (value) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (categoriesGroup && value && value.trim() !== '') {
        const { openedPanels, openedSubPanels } = getPanelOpenValues(categoriesGroup, value);
        setOpenPanels(openedPanels);
        setOpenSubPanels(openedSubPanels);
      } else {
        setOpenPanels([]);
        setOpenSubPanels([]);
      }
      clearTimeout(timer);
    }, 300);
  };

  useEffect(() => {
    setCategoriesGroup(getCategory(categories, categoriesData, searchValue) || []);
  }, [searchValue, categoriesData]);

  useEffect(() => {
    debouncedSearch(searchValue);
  }, [searchValue]);

  return (
    <div className="mo__system-elements-list">
      <div className="details">
        <div>
          <Tooltip title="Filter">
            <Button
              onClick={toggleFilterComponentModal}
              disabled={!categoriesGroup.length}
              type="link"
              style={{ position: 'absolute', padding: '0', right: '10px' }}
            >
              <FilterFilled style={{ fontSize: '14px' }} />
            </Button>
          </Tooltip>
        </div>
        <div style={{ margin: '1rem 2.25rem 1rem 1rem' }}>
          <SearchForm placeholder={`${isWindow() ? 'Ctrl' : '⌘'} + K to Search`} onDataSearch={setSearchValue} />
        </div>
        <div className="elements">
          {categoriesGroup.length ? (
            <Collapse
              expandIcon={({ isActive }) => (
                <div className="expand-icon">
                  <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: '16px' }} />
                </div>
              )}
              bordered={false}
              className="collapse"
              onChange={setOpenPanels}
              activeKey={openedPanels}
            >
              {!categoriesGroup.length ? (
                <span className={'no-result'}>
                  No components <br /> match your search.
                </span>
              ) : (
                categoriesGroup.map(
                  (item) =>
                    isShowCate(item) && (
                      <Panel
                        key={item.groupId}
                        header={item.categoryName}
                        extra={
                          isSubCate(item) ? (
                            ''
                          ) : (
                            <Tooltip title="Deselect" placement="right" ouseLeaveDelay={0}>
                              <CloseOutlined onClick={() => removeFilterOption(item)} />
                            </Tooltip>
                          )
                        }
                      >
                        {item.subCategoryList
                          ? item.subCategoryList.map((i) => {
                              if (filterList.find((item) => item === i.groupId)) return renderComponent(i);
                            })
                          : item.componentList && (
                              <div
                                className={
                                  componentObj.componentType === MAIN_MENU.icons.componentType ||
                                  componentObj.componentType === MAIN_MENU.diagrams.componentType
                                    ? 'display-4'
                                    : 'display-2'
                                }
                              >
                                {item.componentList.map((i) => renderComponent(i))}
                              </div>
                            )}
                      </Panel>
                    ),
                )
              )}
            </Collapse>
          ) : (
            <div style={{ padding: '0 10px', height: '100%' }}>
              <Skeleton active />
            </div>
          )}
        </div>
      </div>
      <FilterComponentModal componentObj={componentObj} visible={isShowModal} onClose={toggleFilterComponentModal} />
    </div>
  );
};

export default SystemComponents;
